import { TextWrapper } from "@/components/TextWrapper";

export default function ClientInLaborCard({ inLabor }: { inLabor: boolean }) {
  if (!inLabor) {
    return null;
  }

  return (
    <TextWrapper
      my={4}
      px={8}
      py={2}
      size="sm"
      c="red.7"
      bg="red.1"
      variant="label"
      style={{ borderRadius: 4 }}
      aria-label="Client In Labor"
    >
      In Labor
    </TextWrapper>
  );
}
